export const readHttpErrorMessageFromUnknown = (err: unknown): string | undefined => {
  if (typeof err !== 'object' || err === null) {
    return undefined;
  }
  if (!('response' in err)) {
    return undefined;
  }
  const responseField: unknown = Reflect.get(err, 'response');
  if (typeof responseField !== 'object' || responseField === null) {
    return undefined;
  }
  if (!('data' in responseField)) {
    return undefined;
  }
  const dataField: unknown = Reflect.get(responseField, 'data');
  if (typeof dataField !== 'object' || dataField === null) {
    return undefined;
  }
  if (!('message' in dataField)) {
    return undefined;
  }
  const messageField: unknown = Reflect.get(dataField, 'message');
  if (typeof messageField !== 'string') {
    return undefined;
  }
  return messageField;
};
